import MemberListPage from './Component/MemberListPage';
import memberRoleConfig from './memberRoleConfig';

const FamilyPage = () => <MemberListPage roleConfig={memberRoleConfig.family} />;

export default FamilyPage;
